import EventEmitter from 'events';
import { SENDER_ACTIONS, SESSIONDATA } from '../models/Engine';
import { VendexFunction } from '../models/VendexAction';
import { LOG_TYPE } from '../models/Log';
import PageData from '../models/PageData';
import { VendexCheckboxMeta, VendexElementType, VendexRadioMeta } from '../models/VendexElement';

const getDefaultData = (pages: PageData[]): SESSIONDATA => {
  const initData: SESSIONDATA = {};
  pages.forEach((page) => {
    page.elements.forEach((el) => {
      if (el.type === VendexElementType.CHECK_BOX && (el.metaData as VendexCheckboxMeta).defaultCheck) {
        initData[(el.metaData as VendexCheckboxMeta).name] = 'checked';
      }
      if (el.type === VendexElementType.RADIO && (el.metaData as VendexRadioMeta).defaultCheck) {
        initData[(el.metaData as VendexRadioMeta).name] = (el.metaData as VendexRadioMeta).value;
      }
    });
  });
  return initData;
};

class ApplicationStore extends EventEmitter {
  private _data: SESSIONDATA = {};

  get data(): SESSIONDATA {
    return this._data;
  }

  set data(value: SESSIONDATA) {
    this._data = value;
    this.emit('DATA_CHANGED');
  }

  constructor(props: { [key: string]: string }, pages: PageData[]) {
    super();
    for (const property in props) {
      const code = props[property];
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (this as any)[property] = new Function(`return ${code}`).bind(this)() as VendexFunction;
    }
    this.data = getDefaultData(pages);
    this.CHANGE_PAGE = this.CHANGE_PAGE.bind(this);
    this.SELECT_PRODUCT = this.SELECT_PRODUCT.bind(this);
    this.PRODUCT_VEND = this.PRODUCT_VEND.bind(this);
    this.SET_DATA = this.SET_DATA.bind(this);
    this.EMAIL_IS_VALID = this.EMAIL_IS_VALID.bind(this);
    this.PHONE_IS_VALID = this.PHONE_IS_VALID.bind(this);
    this.ZIP_IS_VALID = this.ZIP_IS_VALID.bind(this);
    this.HAS_VALUE = this.HAS_VALUE.bind(this);
    setTimeout(()=> {
      this.emit('DATA_CHANGED');
    }, 500)
  }

  CHANGE_PAGE = (payload: string): boolean => {
    document.dispatchEvent(
      new CustomEvent('CHANGE_PAGE', {
        bubbles: false,
        detail: {
          page: payload
        },
      })
    );
    return true;
  };

  SELECT_PRODUCT = (payload?: string): boolean => {
    if (typeof payload !== 'string') {
      return false;
    } else {
      this.data = { ...this.data, Product: payload };
      return true;
    }
  };

  PRODUCT_VEND = (): boolean => {
    window.SENDER({ type: SENDER_ACTIONS.VEND, payload: this.data['product'] });
    return true;
  };

  SET_DATA = (payload?: string): boolean => {
    if (typeof payload != 'string') return false;
    const a = payload.split(',');
    if (!a[1]) return false;
    this.data = { ...this.data, [a[0].trim()]: a[1].trim() };
    return true;
  };

  EMAIL_IS_VALID = (payload?: string): boolean => {
    if (typeof payload !== 'string') {
      return false;
    } else {
      const value = this.data[payload];
      if (!value) return false;
      const exp = new RegExp(
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      return exp.test(value);
    }
  };

  PHONE_IS_VALID = (payload?: string): boolean => {
    if (typeof payload !== 'string') {
      return false;
    } else {
      const value = this.data[payload];
      if (!value) return false;
      const regex = new RegExp(/^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/);
      return regex.test(value);
    }
  };

  ZIP_IS_VALID = (payload?: string): boolean => {
    if (typeof payload !== 'string') {
      return false;
    } else {
      const value = this.data[payload];
      if (!value) return false;
      return value.length === 5;
    }
  };

  HAS_VALUE = (payload?: string): boolean => {
    if (typeof payload !== 'string') {
      return false;
    } else {
      const value = this.data[payload];
      if (!value) return false;
      return value.toString().length > 0;
    }
  };

  LOG_ACTION = (type: LOG_TYPE, payload = '') => {
    window.LOGGER({ type, payload });
  };
}
export default ApplicationStore;
